import { anyAsciiCode } from "../../../../_base/helper/AnyAscii";
import type { ScannedSerialRow } from "../types";

/**
 * Chuẩn hoá mã quét: bỏ khoảng trắng hai đầu, bỏ dấu tiếng Việt, viết hoa.
 * Trang cũ hiển thị mã đã viết hoa nhưng gửi lên giá trị gõ thô; ở đây gửi đúng giá trị hiển thị.
 */
export const normalizeSerial = (raw: string | null | undefined): string =>
  anyAsciiCode(String(raw ?? "").trim()).toLocaleUpperCase();

const normalizedByRow = new WeakMap<ScannedSerialRow, string>();
/** normalizeSerial(row.serial), mỗi object dòng chỉ tính một lần (serial không sửa được trên lưới) */
export const normalizedSerialOf = (row: ScannedSerialRow): string => {
  let value = normalizedByRow.get(row);
  if (value === undefined) {
    value = normalizeSerial(row.serial);
    normalizedByRow.set(row, value);
  }
  return value;
};

const serialSetByRows = new WeakMap<ScannedSerialRow[], Set<string>>();
/** Tập serial đã chuẩn hoá của một mảng rows; trang và hook quét dùng chung (chỉ đọc) */
export const scannedSerialSetOf = (rows: ScannedSerialRow[]): Set<string> => {
  let set = serialSetByRows.get(rows);
  if (!set) {
    set = new Set<string>();
    for (const row of rows) set.add(normalizedSerialOf(row));
    serialSetByRows.set(rows, set);
  }
  return set;
};
